import {
  downloadQrPng,
  resolveQrBaseUrl,
  sanitizeQrFilePart,
} from '@/utils/qrCode.utils';

export { downloadQrPng };

export function buildArtworkQrFilename(artworkData, extension = 'png') {
  const slug = sanitizeQrFilePart(artworkData?.slug);
  const title = sanitizeQrFilePart(artworkData?.artwork_about?.artwork_title);
  const fallback = sanitizeQrFilePart(artworkData?._id) || 'artwork';
  return `suarte-qr-${slug || title || fallback}.${extension}`;
}

export function normalizeArtworkQrPayload(artworkData) {
  const qr = artworkData?.artwork_qr;
  const token = typeof qr?.token === 'string' ? qr.token.trim() : '';
  if (!token) {
    return null;
  }

  const baseUrl = resolveQrBaseUrl();

  return {
    token,
    qrUrl: qr.qrUrl || `${baseUrl}/q/artwork/${encodeURIComponent(token)}`,
    targetUrl: qr.targetUrl || (artworkData?.slug ? `${baseUrl}/artwork/${encodeURIComponent(artworkData.slug)}` : baseUrl),
    isActive: qr.isActive,
    fallbackUrl: qr.fallbackUrl || baseUrl,
    createdAt: qr.created_at || qr.createdAt || null,
    createdByGalleryId: qr.created_by_gallery_id || qr.createdByGalleryId || null,
  };
}
